import { useConfirm } from '@genial/components';
import { Utils, useBreakpointValue } from '@genial/utils';
import { useRecoilValue } from 'recoil';

import { useBatchTicketActions } from '../../../store/batchTicket/actions';
import { basketAdvisorOrderIdState, productsCartState } from '../../../store/batchTicket/atom';
import {
  investmentsSummarySelector,
  productsCartCountSelector,
} from '../../../store/batchTicket/selectors';
import { AddedProductItemData } from '../utils/types';

export const useProductsAdded = () => {
  const { confirm } = useConfirm();
  const { cleanProductCart } = useBatchTicketActions();
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const basketAdvisorOrderId = useRecoilValue(basketAdvisorOrderIdState);

  const investmentsSummary = useRecoilValue(investmentsSummarySelector);
  const productsCart = useRecoilValue(productsCartState);

  const productAddedCart = [
    {
      type: 'fixedIncome',
      id: '0',
      assetCount: productsCart.fixedIncome.items.length,
      total: investmentsSummary.totalsByCategory.fixedIncome,
      totalFormatted: Utils.Mask.Money(investmentsSummary.totalsByCategory.fixedIncome),
      items: productsCart.fixedIncome.items,
    },
    {
      type: 'funds',
      id: '1',
      assetCount: productsCart.funds.items.length,
      total: investmentsSummary.totalsByCategory.funds,
      totalFormatted: Utils.Mask.Money(investmentsSummary.totalsByCategory.funds),
      items: productsCart.funds.items,
    },
    {
      type: 'equity',
      id: '2',
      assetCount: productsCart.equity.items.length,
      total: investmentsSummary.totalsByCategory.equity,
      totalFormatted: Utils.Mask.Money(investmentsSummary.totalsByCategory.equity),
      items: productsCart.equity.items,
    },
    {
      type: 'coes',
      id: '3',
      assetCount: productsCart.coes.items.length,
      total: investmentsSummary.totalsByCategory.coes,
      totalFormatted: Utils.Mask.Money(investmentsSummary.totalsByCategory.coes),
      items: productsCart.coes.items,
    },
    {
      type: 'directTreasury',
      id: '4',
      assetCount: productsCart.directTreasury.items.length,
      total: investmentsSummary.totalsByCategory.directTreasury,
      totalFormatted: Utils.Mask.Money(investmentsSummary.totalsByCategory.directTreasury),
      items: productsCart.directTreasury.items,
    },
  ] as unknown as AddedProductItemData[];

  const productCartCountAll = useRecoilValue(productsCartCountSelector);
  const productCartCount = productCartCountAll.products;
  const productAssetsCount = productCartCountAll.assets;
  const productCartTotalAvailableBalance = {
    total: investmentsSummary.totalSum,
    totalFormatted: Utils.Mask.Money(investmentsSummary.totalSum),
  };
  const productCartIsEmpty = productCartCountAll.assets === 0;

  const handleResetProductCart = () => {
    confirm(
      {
        isMobile,
        title: 'Atenção',
        description:
          'Está ação limpará os dados salvos até o momento.\nDeseja continuar mesmo assim?',
        icon: 'Warning',
        confirmText: 'Continuar',
        confirmColor: 'feedback.error.default',
      },
      () => cleanProductCart(basketAdvisorOrderId!)
    );
  };

  return {
    productAddedCart,
    productCartCount,
    productAssetsCount,
    productCartTotalAvailableBalance,
    productCartIsEmpty,
    resetProductCart: handleResetProductCart,
  };
};
